import isString from 'lodash/isString';

const isStatic = (str = '') => isString(str) && str.startsWith('/static/');

export default isStatic;
